<script>
import sumBy from 'lodash/sumBy';
import get from 'lodash/get';
import { mapState, mapGetters } from 'vuex';

import Top from './HeaderBottomMobileTop';
import Bottom from './HeaderBottomMobileBottom';

export default {
  components: {
    Top,
    Bottom,
  },
  props: {
    cart: Object,
    search: String,
    marketplaceCategories: Array,
    userLoggedIn: Boolean,
    cartRoute: String,
    checkoutRoute: String,
    scrollingUp: Boolean,
    hideFixedHeader: Boolean,
    isMobileSalesPage: Boolean,
    currentScrollTop: Number,
    isWhitelabel: [Boolean, String],
  },
  data: () => ({
    showShopByMenu: false,
    scrollUpTimeout: null,
  }),
  computed: {
    ...mapState({
      processing: state => state.processing,
    }),
    ...mapGetters(['cartQuantity']),
  },
  watch: {
    async scrollingUp(newVal, oldVal) {
      clearTimeout(this.scrollUpTimeout);

      if (!newVal) {
        await this.$nextTick();

        this.$refs.headerBottomFixed.classList.add('overflow-hidden');
      } else {
        this.scrollUpTimeout = setTimeout(() => this.$refs.headerBottomFixed.classList.remove('overflow-hidden'), 250);
      }
    },
    async hideFixedHeader(newVal) {
      await this.$nextTick();

      if (newVal) {
        this.$refs.headerBottomFixed.classList.add('overflow-hidden');
      } else if (!newVal && !this.scrollingUp) {
        this.$refs.headerBottomFixed.classList.add('overflow-hidden');
      }
    }
  },
  methods: {
    toggleShopMenu(e) {
      e.stopPropagation();

      this.showShopByMenu = !this.showShopByMenu;

      this.$store.commit('lockScroll', this.showShopByMenu);
    },
  },
};
</script>

<template lang='pug'>
.border-b.border-border.pb-1

  .bg-white.header-bottom-mobile.pt-1
    top(
      :user-logged-in='userLoggedIn',
      :cart-qty='cartQuantity',
      :is-whitelabel='isWhitelabel',
      :cart='cart',
      @log-out='$emit("log-out")',
      @open-menu='$emit("open-menu")'
    )
      slot

  bottom(
    v-if='!isMobileSalesPage',
    :cart-route='cartRoute',
    :checkout-route='checkoutRoute',
    :cart='cart',
    :search='search',
    :categories='marketplaceCategories',
    :is-whitelabel='isWhitelabel',
    @toggle-shop-menu='toggleShopMenu',
    @search-input='$emit("search-input", $event)',
    @perform-search='$emit("perform-search", $event)',
  )

  //- fixed header
  .bg-white.header-bottom-mobile.py-1.fixed.top-0.w-full.z-103(
    v-if='currentScrollTop > 0 && !isMobileSalesPage',
    :class='{ "border-b border-border": !scrollingUp || hideFixedHeader }'
  )
    top(
      :user-logged-in='userLoggedIn',
      :cart-qty='cartQuantity',
      :is-whitelabel='isWhitelabel',
      :cart='cart',
      @log-out='$emit("log-out")',
      @open-menu='$emit("open-menu")'
    )
      slot

  .z-102.w-full.bg-white.fixed.transition-all.transition-250(
    ref='headerBottomFixed',
    :class='{ "hidden": hideFixedHeader || isMobileSalesPage }',
    :style='{ top: "45px", height: scrollingUp && !hideFixedHeader ? [cartRoute, checkoutRoute].includes($route.name) || isWhitelabel ? "62px" : "97px" : "0" }',
  )

    bottom(
      :cart-route='cartRoute',
      :checkout-route='checkoutRoute',
      :cart='cart',
      :search='search',
      :categories='marketplaceCategories',
      :is-whitelabel='isWhitelabel',
      @toggle-shop-menu='toggleShopMenu',
      @search-input='$emit("search-input", $event)',
      @perform-search='$emit("perform-search", $event)',
    )

    .border-b.border-border.pt-1.h-px(:class='{ hidden: !scrollingUp }')
  //- end fixed header

  //- shop by menu
  .fixed.top-0.left-0.w-full.h-full.z-1000(
    v-if='!isWhitelabel'
    v-show='showShopByMenu',
  )
    .bg-black.opacity-25.h-full.w-full(
      @click='toggleShopMenu',
    )
    .absolute.absolute--center.w-3-4.text-white.text-center.pb-1.h-full
      .fixed.text-right.top-0.right-0
        svg.h-2.inline-block.mt-6.mr-1(
          tabindex='0',
          viewBox='0 0 24 24',
          @click='toggleShopMenu',
          @keyup.enter='toggleShopMenu',
        )
          path.fill-current(d='M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z')
      .overflow-auto.max-h-3-4.rounded.bg-brand.mt-5.py-1
        router-link.text-3xl.p-_5(
          v-for='category in marketplaceCategories',
          tabindex='0',
          tag='div',
          :key='category.slug',
          :to='{ name: "marketplace", query: { category: category.value }, params: { page: "1", nav: true } }',
          @click.native='toggleShopMenu',
          @keyup.enter.native='toggleShopMenu',
        )
          a.transition-250.transition-color.hover_text-white.cursor-pointer {{category.text}}
</template>

<style>
@import '~import/index';
.header-bottom {
  $self: &;

  @include mq(sm) {

    &__search,
    &__links {
      margin-top: 1rem;
      transition: all 250ms;
    }

    &__search {
      height: 38px;
    }

    &__links {
      height: 22px;
    }

    &--collapsed {

      #{$self}__search,
      #{$self}__links {
        height: 0;
        margin-top: 0;
        overflow: hidden;
      }
    }
  }
}
</style>